import ClinicianPlaceholder from './ClinicianPlaceholder';

const Analytics: React.FC = () => {
  return (
    <ClinicianPlaceholder
      title="Analytics"
      subtitle="Analyze screening data, patterns, and trends across ADAPT-MH."
    />
  );
};

export default Analytics;
